<script>
import Multiselect from "@vueform/multiselect";
import "@vueform/multiselect/themes/default.css";
import {circleEcharts} from '@/utils/chart'
import Layout from "../../layouts/main";
import appConfig from "../../../app.config";
// import PageHeader from "@/components/page-header";
import {
  // auditingEngineer,
  auditingList,
  customers,
  feedbackExport, feedbackImport, saleEngineer, statisticsAuditing,
  // getUploadFileDetail,
  // getUploadFileSign,
  // statisticsOrder
} from "@/service";
// import { getCompany } from "@/helpers/common-service";
import { formatDatetime, getTimezone } from "@/helpers/common";
import {
  WorkOrderStatus,
  WorkOrderPriority,
  WorkOrderWarrantyStatus,
  WO_TYPE,
  // WO_STATUS_TO_BE_ASSIGNED,
  // WO_STATUS_TO_BE_CONSTRUCTED
  AUDITING_ORDER_REPORT_STAUTS
} from "@/config/common";
import _ from "lodash";
import WoStatusEtc from "@/views/auditing-order/components/widgets/wo-status-etc";
import TableLoading from "@/views/widgets/table-loading";
import i18n from "@/i18n";
import feedbackFilter from "@/views/auditing-order/components/widgets/feedback-filter.vue";
import { CountTo } from "vue3-count-to";
import {imageCompress} from "@/utils/common";
import Swal from "sweetalert2";
// import axios from "axios";
// import { v4 as uuidv4 } from "uuid";
import DropZone from "@/components/widgets/dropZone.vue";
import {ElMessage} from "element-plus";
import moment from "moment"
const priorityOptions = _.cloneDeep(WorkOrderPriority);
priorityOptions.unshift({ value: "", label: i18n.global.t("page.all") });
const orderStatusOptions = _.cloneDeep(WorkOrderStatus);
orderStatusOptions.unshift({ value: "", label: i18n.global.t("page.all") });
const orderTypeOptions = _.cloneDeep(WO_TYPE);
orderTypeOptions.unshift({ value: "", label: i18n.global.t("page.all") });

let routeFrom = null;

export default {
  name: "work-order",
  page: {
    title: "设备巡检工单",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  data() {
    return {
      WO_TYPE,
      AUDITING_ORDER_REPORT_STAUTS,
      WorkOrderPriority,
      title: this.$t('page.auditing.title'),//"设备巡检工单",
      /* 分页start */
      tab_info_length: 0,
      page: 1,
      perPage: 10,
      prePageOption: [10, 20, 30, 40, 50],
      pages: [],
      /* 分页end */
      value: null,
      status: null,
      status1: "",
      checkTabVal: "0",
      tabOptions: [
        {
          value: "0",
          text: this.$t("page.work-order.all-order"),
          icon: "ri-layout-grid-fill",
          tipNum: 0,
        },
        {
          value: "1",
          text: this.$t("page.work-order.status.pending-construction"),//"待施工",
          icon: "ri-time-fill",
          tipNum: 0,
        },
        {
          value: "2",
          text: this.$t("page.work-order.status.under-construction"),//"施工中",
          icon: "ri-creative-commons-by-fill",
          tipNum: 0,
        },
        {
          value: "3",
          text: this.$t("page.work-order.status.completed"),
          icon: "ri-checkbox-circle-fill",
          tipNum: 0,
        },
        {
          value: "4",
          text: this.$t("page.work-order.status.canceled"),
          icon: "ri-close-circle-fill",
          tipNum: 0,
        }
      ],
      config: {
        altFormat: "Y-m-d",
        altInput: true,
        dateFormat: "Y-m-d",
      },
      date2: null,
      priorityOptions,
      statusOptions: orderStatusOptions,
      warrantyOptions: WorkOrderWarrantyStatus,
      orderTypeOptions,
      showAllColumns: false,
      tableHeaders: [
        {
          name: "number",
          label: this.$t('page.auditing.work_order_number'),//"工单编号",
          visible: true,
          rowspan:1
        },
        {
          name: "type_txt",
          label:this.$t('page.auditing.type'), //"类型",
          visible: true,
          rowspan:1

        },
        {
          name: "ka_level",
          label: this.$t('page.auditing.customer_level'),//"客户等级",
          visible: true,
          rowspan:1

        },
        {
          name: "deadline",
          label: this.$t('page.auditing.latest_completion_time'),//"最晚完成时间",
          visible: true,
          rowspan:1

        },
        {
          name: "status",
          label: this.$t('page.auditing.work_order_status'),// "工单状态",
          visible: true,
          rowspan:1

        },
        {
          name: "is_delay",
          label: this.$t('page.auditing.delay_status'),//"延期状态",
          visible: true,
          rowspan:1

        },

        {
          name: "customer_txt",
          label: this.$t('page.auditing.customer_name'),//"客户名称",
          visible: true,
          rowspan:1

        },
        {
          name: "service_company_txt",
          label: this.$t('page.auditing.service_provider'),//"维保服务商",
          visible:true,
          rowspan:1

        },
        {
          name: "owner_engineer_txt",
          label:this.$t('page.auditing.sales_service_engineer'),//"销售服务工程师",
          visible: true,
          rowspan:1

        },
        {
          name: "auditing_order_report.contact_name",
          label: this.$t('page.auditing.contact'),//"联系人",
          visible: true,
          rowspan:1

        },
        {
          name: "auditing_order_report.contact_number",
          label: this.$t('page.auditing.contact_phone'),//"联系电话",
          visible: true,
          rowspan:1

        },

        {
          name: "auditing_order_report.status",
          label: this.$t('page.auditing.service_report_status'),//"服务报告状态",
          visible: true,
          rowspan:1

        },
        {
          name: "auditing_order_report.amount",
          label: this.$t('page.auditing.amount'),//"金额",
          visible: false,
          rowspan:1

        },
        {
          name: "auditing_order_report.possibility",
          label: this.$t('page.auditing.order_feasibility'),//"成单可行性",
          visible: false,
          rowspan:1

        },
      ],
      visibleFields: [], // 显示的字段，按点击的顺序展示
      tableLoading: false,
      tableLoaded: false,
      orders: [],
      count: 0,
      filters: {
        page: 1,
        page_size: 10,
      },
      filter_value: {
        keyword: "",
        date: null,
        priority: null,
        status: "0",
        is_reassign: null,
        type: null,
        feedback: [],
        engineer:'',
        customer:''
      },
      checkedIds: [],
      checkedAll: false,
      topCardList: [
        {
          name: this.$t("page.work-order.WorkOrdersThisMonth"), //本月工单
          name1: '',
          value: 0,
          value1: 0,
          icon:' ri-file-text-line'
        },
        {
          name: this.$t("page.work-order.status.under-construction"),//'施工中'
          name1: this.$t("page.work-order.TotalPendingAssignment"),
          value: 0,
          value1: 0,
          icon:' ri-send-plane-fill'

        },
        {
          name: this.$t("page.work-order.status.pending-construction"),//'待施工'
          name1: this.$t("page.work-order.TotalClosedWorkOrders"),
          value: 0,
          value1: 0,
          icon:'ri-checkbox-circle-line'

        },
        {
          name: this.$t("page.work-order.status.completed"),//'已完成'
          name1: this.$t("page.work-order.TotalCanceledWorkOrders"),
          value: 0,
          value1: 0,
          icon:'ri-close-circle-line'

        },
      ],
      clientName:[],
      engineer:[],
      reportModal:false,
      showfiles:{image: [], video: [], document: []},
      colors:[
        { color: '#f56c6c', percentage: 20 },
        { color: '#e6a23c', percentage: 40 },
        { color: '#5cb87a', percentage: 60 },
        { color: '#1989fa', percentage: 80 },
        { color: '#6f7ad3', percentage: 100 },
      ]
    };
  },
  components: {
    DropZone,
    TableLoading,
    WoStatusEtc,
    Layout,
    // PageHeader,
    Multiselect,
    feedbackFilter,
    CountTo,
  },
  computed: {
    visibleTableHeaders() {
      // 默认显示全部
      if (!this.showAllColumns) {
        return _.cloneDeep(this.tableHeaders);
      }
      // 根据点击的顺序展示
      return _.map(this.visibleFields, (fieldName) =>
        _.find(this.tableHeaders, ["name", fieldName])
      );
    },
    user() {
      return JSON.parse(localStorage.getItem("user"));
    },
  },
  mounted() {
    // this._getFirstPage()

    this._orderNum();
    this.getcustomers()
    this.getauditingEngineer()
    this.getStatisticsAuditing()


  },
  beforeRouteEnter(to, from, next) {
    routeFrom = from.name;
    next()// 放行
  },
  /* activated不得不提到keep-alive，你切换出去又切出来会调用到它 */ 
  activated() {
    this.refresh(routeFrom === "work-order-detail");
  },
  methods: {
    moment,
    getStatisticsAuditing(){
      statisticsAuditing().then(res=>{
        console.log(res)
        this.topCardList[0].value=res.payload.month_total
        this.topCardList[1].value=res.payload.doing_total
        this.topCardList[2].value=res.payload.todo_total
        this.topCardList[3].value=res.payload.completed_total
        // completed_growth_rate

      })
    },
    //客户
    getcustomers(){
      let params={
        page_size:0,
      }
      customers(params).then(res=>{
        res.payload.map((a) => {
          this.clientName.push({
            label: a.name,
            value: a.id,
            key: a.id + "",
          });
        });
      })
    },
    //工程师
    getauditingEngineer(){
      let params={
        page_size:0,
      }
      saleEngineer(params).then(res=>{
        res.payload.map((a) => {
          this.engineer.push({
            label: a.name,
            value: a.id,
            key: a.id + "",
          });
        });
      })
    },
    /* 环形进度条 */
    initChart(form) {
      for (let i = 0; i < form.length; i++) {
        let chartDom = document.getElementById(`progress${i}`);
        if (chartDom) {
          chartDom.style.width = 40 + "px";
          chartDom.style.height = 40 + "px";
        }
        if(form.auditing_order_report&&form.auditing_order_report[i]&&form.auditing_order_report[i].possibility){
          let percent = parseFloat(form.auditing_order_report&&form.auditing_order_report[i]&&form.auditing_order_report[i].possibility);
          let dataList = [{
            value: percent, //占比
          },
            {
              value: 100 - percent,
            },
          ];
          let color = ["#117B6C", "#e9ebec"];

          let lineCorlor = "#f1a9a6";
          let options = {
            chartDom,
            dataList,
            color,
            lineCorlor,
          };
          circleEcharts(options);
        }

      }
    },

    formatDatetime,
    getLabel(options, val) {
      if (!val) {
        return "";
      }
      const item = _.find(options, ["value", parseInt(val)]);
      if (!item) {
        return "";
      }
      return _.get(item, "label");
    },
    // 设置显示列
    changeShowAllColumns() {
      this.tableHeaders.forEach((i) => {
        i.visible = this.showAllColumns;
      });
      if (!this.showAllColumns) {
        this.visibleFields = [];
      } else {
        this.visibleFields = _.map(this.tableHeaders, "name");
      }
    },
    changeShowColumn(fieldName) {
      if(this.tableHeaders.every(header=>header.visible)){
        this.showAllColumns = true
      }else{
        this.showAllColumns = false
      }
      let result = []
      this.tableHeaders.map(item=>{
        if(item.visible){
          result.push(item.name)
        }
      })
      this.visibleFields = result
      
      // this.visibleFields = _.xor(this.visibleFields, [fieldName]);
    },
    checkAllChange() {
      if (this.checkedAll) {
        // 将所有ID追加到数组并去重
        this.checkedIds = _.uniq(
          _.concat(this.checkedIds, _.map(this.orders, "id"))
        );
      } else {
        this.checkedIds = [];
      }
    },
    checkChange(id) {
      this.checkedIds = _.xor(this.checkedIds, [id]);
    },
    /* 设置分页选项 */
    setPages() {
      this.pages = [];
      this.tab_info_length = this.count;
      let numberOfPages = Math.ceil(this.count / this.perPage);
      for (let index = 1; index <= numberOfPages; index++) {
        this.pages.push(index);
      }
    },
    // 导出
    download() {
      // 当前的筛选条件：this.filters， 当前选择的字段：this.visibleTableHeaders

      const keyMap = {
        // priority: 'priority_txt',
        // status: 'status_txt',
        engineer: "main_engineer_txt",
      };
      // columns是一个字典，格式如：{key:title}，从this.visibleTableHeaders中获取name作为columns的key,label作为columns的title，且需要将priority,status的key转换为priority_txt,status_txt，engineer的key转换为main_engineer_txt
      let columns = _.map(this.visibleTableHeaders, (item) => {
        const key = keyMap[item.name] || item.name;
        return {
          [key]: item.label,
        };
      });
      columns = _.assign({}, ...columns);
      // param的格式如：{key:value}，从this.filters中获取key作为param的key,value作为param的value，删除page和page_size，删除value为null的key
      const param = _.omitBy(
        _.mapValues(this.filters, (value, key) => {
          if (key === "page" || key === "page_size") {
            return null;
          }
          return value;
        }),
        _.isNull
      );
      const langs = {
        type: WO_TYPE.reduce((obj, item) => {
          obj[item.value] = item.label;
          return obj;
        }, {}),
        priority: WorkOrderPriority.reduce((obj, item) => {
          obj[item.value] = item.label;
          return obj;
        }, {}),
        status: {
          ...WorkOrderStatus.reduce((obj, item) => {
            obj[item.value] = item.label;
            return obj;
          }, {}),
          5: this.$t("page.work-order.status.reassign"),
          6: this.$t("page.work-order.status.unconfirmed"),
          7: this.$t("page.work-order.status.under-construction"),
        },
      };
      const params = {
        params: param,
        columns,
        langs,
        tz: getTimezone(),
        file_name: this.$t("page.work-order-download-title"),
      };
      feedbackExport(params).then((res) => {
        window.open(
          "/service-report-download/" + res.payload.request_id + "?type=auditing",
          "_blank",
          "noreferrer"
        );
      });
    },
    // 新建工单
    add() {
      this.$router.push("/auditing-order-add/1");
    },
    refresh(currentPage) {
      if (currentPage) {
        // 只刷新当前页，筛选条件和页码都不变
        this._getList();
      } else {
        // 刷新整个页面的数据
        this.filter_value.status = "0";
        this.resetSearch();
        this.getStatisticsAuditing()
      }
    },
    // 筛选
    doFilter() {
      this.orders = [];
      const search = {
        keyword: null,
        created_at: null,
        priority: null,
        status: null,
        is_reassign: null,
        is_assigned: null,
        is_checkin: null,
        created_at_before: null,
        created_at_after: null,
        type: null,
        fb_quality_max: null,
        fb_quality_min: null,
        fb_attitude_max: null,
        fb_attitude_min: null,
        fb_response_speed_max: null,
        fb_response_speed_min: null,
        customer:null,
        engineer:null
      };
      if (this.filter_value.keyword) {
        search["keyword"] = this.filter_value.keyword;
      }
      if (this.filter_value.date) {
        search["created_at_before"] = this.filter_value.date;
        search["created_at_after"] = this.filter_value.date;
      }
      if (this.filter_value.priority) {
        search["priority"] = this.filter_value.priority;
      }
      if (this.filter_value.status) {
        // 待派工
        if (this.filter_value.status == 1) {
          search["status"] = 1
        }

        // 待施工
        if (this.filter_value.status == 2) {

          search["status"] = 2
        }

        if(this.filter_value.status == 3){
          search["status"] = 3

        }
        if(this.filter_value.status == 4){
          search["status"] = 4

        }
      }
      if (this.filter_value.engineer) {
        search["engineer"] = this.filter_value.engineer;
      }
      if (this.filter_value.customer) {
        search["customer"] = this.filter_value.customer;
      }
      if (this.filter_value.feedback.length) {
        if (this.filter_value.feedback.includes("quality_bad")) {
          search["fb_quality_max"] = 2;
        }
        if (this.filter_value.feedback.includes("quality_good")) {
          search["fb_quality_min"] = 3;
        }
        if (this.filter_value.feedback.includes("attitude_bad")) {
          search["fb_attitude_max"] = 2;
        }
        if (this.filter_value.feedback.includes("attitude_good")) {
          search["fb_attitude_min"] = 3;
        }
        if (this.filter_value.feedback.includes("response_speed_bad")) {
          search["fb_response_speed_max"] = 2;
        }
        if (this.filter_value.feedback.includes("response_speed_good")) {
          search["fb_response_speed_min"] = 3;
        }
      }

      this.filters = _.assign(this.filters, search);
      console.log("---------this.filters------",this.filters);
      this._getFirstPage();
      this._orderNum();
    },
    // 重置
    resetSearch() {
      // this.filter_value.status = null
      this.filter_value.date = null;
      this.filter_value.priority = null;
      this.filter_value.keyword = null;
      this.filter_value.type = null;
      this.filter_value.feedback = [];
      this.filter_value.engineer='';
      this.filter_value.customer='';
      this.doFilter();
    },
    // 状态筛选
    checkTab(val) {
      // 待施工
      this.filter_value.status = val;
      this.doFilter();
    },
    // 翻页
    pageChange(val) {
      this.filters.page = val;
      this._getList();
    },
    // 设置每页条数
    pageSizeChange(val) {
      this.filters.page_size = val;
      this._getFirstPage();
    },
    // 获取数据
    _getFirstPage() {
      this.page = 1;
      this.filters.page = 1;
      this.checkedAll = false;
      this.checkedIds = [];
      this._getList();
    },
    _getList() {
      this.filters.page_size = this.perPage;
      this.tableLoading = true;
      this.tableLoaded = false;
      this.orders = [];
      console.log(this.filters)
      auditingList(this.filters)
        .then((res) => {
          this.tableLoading = false;
          this.tableLoaded = true;
          this.orders = res.payload.results;
          this.count = res.payload.count;


          // 如果是全选状态，将当前页的所有ID追加到数组并去重
          if (this.checkedAll) {
            this.checkedIds = _.uniq(
              _.concat(this.checkedIds, _.map(this.orders, "id"))
            );
          }
          // 获取服务商名称
          // getCompany().then((companies) => {
          //   const companyNames = companies.reduce((obj, item) => {
          //     obj[String(item.id)] = item.name;
          //     return obj;
          //   }, {});
          //   this.orders = _.map(this.orders, (o) => {
          //     o.service_company_txt = companyNames[o.service_company];
          //     return o;
          //   });
          // });


          this.setPages();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 查待派工、待确认、待转派、待施工的工单数量
    _orderNum() {
      const p = _.assign({}, this.filters,
          {
            page: 1,
            page_size: 10,
            status: 1,
            keyword: this.filter_value.keyword,
            engineer: this.filter_value.engineer,
            customer: this.filter_value.customer
          });
      // 待派工
      auditingList({
        ...p,
      }).then((res) => {

        this.tabOptions[1].tipNum = res.payload.count;

      });
      const p2 = _.assign({}, this.filters,
          {
            page: 1,
            page_size: 10,
            status: 2,
            keyword: this.filter_value.keyword,
            engineer: this.filter_value.engineer,
            customer: this.filter_value.customer
          });
      // 待派工
      auditingList({
        ...p2,
      }).then((res) => {

        this.tabOptions[2].tipNum = res.payload.count;

      });
      const p3 = _.assign({}, this.filters,
          {
            page: 1,
            page_size: 10,
            status: 3,
            keyword: this.filter_value.keyword,
            engineer: this.filter_value.engineer,
            customer: this.filter_value.customer
          });
      // 待派工
      auditingList({
        ...p3,
      }).then((res) => {

        this.tabOptions[3].tipNum = res.payload.count;

      });
      const p4 = _.assign({}, this.filters,
          {
            page: 1,
            page_size: 10,
            status: 4,
            keyword: this.filter_value.keyword,
            engineer: this.filter_value.engineer,
            customer: this.filter_value.customer
          });
      // 待派工
      auditingList({
        ...p4,
      }).then((res) => {

        this.tabOptions[4].tipNum = res.payload.count;

      });
    },
    checkFile(file) {
      let name = /^device\//.test(file.name)
          ? file.name.substring(44)
          : file.name;
      let suffix = name.substring(name.lastIndexOf("."));
      let type = /\.(png|jpeg|jpg)$/.test(suffix)
          ? "image"
          : /\.(ppt|pptx|pdf|xls|xlsx|doc|docx)$/.test(suffix)
              ? "document"
              : "video";
      let i = this.showfiles[type].findIndex((item) => {
        let object_name = /^device\//.test(item.object_name)
            ? item.object_name.substring(44)
            : item.object_name;
        return object_name === name;
      });
      return i == -1;
    },
    async selectedFile() {
      let dropzoneFile = document.querySelector(".dropzoneFile").files[0];
      if (!dropzoneFile) return;
      if (dropzoneFile.size > this.fileMaxSize) {
        this.$emit(
            "openAlert",
            {
              variant: "danger",
              content: this.$t('page.files_upload.file_size_cannot_exceed_50M'),
              icon: "ri-error-warning-line",
            },
            false
        );
        document.getElementById("dropzoneFile").value = "";
        return;
      }
      if (!this.checkFile(dropzoneFile)) {
        this.$emit(
            "openAlert",
            {
              variant: "danger",
              content: this.$t('page.files_upload.same_name_file'),
              icon: "ri-error-warning-line",
            },
            false
        );
        document.getElementById("dropzoneFile").value = "";
        return;
      }
      let suffix = dropzoneFile.name.substring(dropzoneFile.name.lastIndexOf("."));
      if(/\.(png|jpeg|jpg)$/.test(suffix)){
        let file = await imageCompress(dropzoneFile)
        this.uploadFileSign(file);
      }else{
        this.uploadFileSign(dropzoneFile);
      }
    },
    uploadFileSign(file) {
      Swal.fire({ title: this.$t('page.files_upload.uploading'), showConfirmButton: false });
      Swal.showLoading();
      // let filename = file.name;
      // let objectName = `device/${uuidv4()}/${filename}`
      let params = new FormData();
      params.append("file",file)
      feedbackImport(params).then((resDetail) => {
        if (resDetail && resDetail.payload) {
          this.reportModal=false
          ElMessage.success('上传成功！')

          document.getElementById("dropzoneFile").value = "";

          Swal.close();
          this.$emit(
              "openAlert",
              {
                variant: "success",
                content: this.$t('base.upload_success'),
                icon: "ri-check-double-line",
              },
              false
          );
        }
      }).catch(() => {
            Swal.close();
            this.$emit(
                "openAlert",
                {
                  variant: "danger",
                  content: this.$t('base.delete_failed_please_try_again'),
                  icon: "ri-error-warning-line",
                },
                false
            );
            document.getElementById("dropzoneFile").value = "";
          });
    },
    async drop(e) {
      let dropzoneFile = e.dataTransfer.files[0];
      if (!dropzoneFile) return;
      if (dropzoneFile.size > this.fileMaxSize) {
        this.$emit(
            "openAlert",
            {
              variant: "danger",
              content: this.$t('page.files_upload.file_size_cannot_exceed_50M'),
              icon: "ri-error-warning-line",
            },
            false
        );
        document.getElementById("dropzoneFile").value = "";
        return;
      }

      if (!this.checkFile(dropzoneFile)) {
        this.$emit(
            "openAlert",
            {
              variant: "danger",
              content: this.$t('page.files_upload.same_name_file'),
              icon: "ri-error-warning-line",
            },
            false
        );
        document.getElementById("dropzoneFile").value = "";
        return;
      }
      let suffix = dropzoneFile.name.substring(dropzoneFile.name.lastIndexOf("."));
      if(/\.(png|jpeg|jpg)$/.test(suffix)){
        let file = await imageCompress(dropzoneFile)
        this.uploadFileSign(file);
      }else{
        this.uploadFileSign(dropzoneFile);
      }
    },
    // 每次筛选条件变化时，更新路由
    // _updateQuery() {
    //   console.log('更新路由')
    //   this.$router.push({
    //     path: this.$route.path,
    //     query: {
    //       ...this.$route.query,
    //       ...this.filters
    //     }
    //   })
    // },
    getReportStautsColor(stauts){
      return AUDITING_ORDER_REPORT_STAUTS[stauts].color;
    }
  },
  watch: {

  },

};
</script>

<template>
  <Layout>
   <b-row >
    <b-col v-for="(a,index) in topCardList" :key="a.name" xxl="3" sm="6">
      <b-card no-body class="card-animate">
        <b-card-body>
          <div class="d-flex justify-content-between" style="height: 100px">
            <div>
              <p class="fw-medium text-muted mb-0">{{ a.name }}</p>
              <h2 class="mt-2 ff-secondary fw-semibold">
                <count-to
                  :startVal="0"
                  :endVal="a.value"
                  :duration="5000"
                ></count-to>
              </h2>
            </div>
            <div class="d-flex flex-wrap align-content-between">
                 <div style="width: 100%"></div>
              <svg v-if="index===0" xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
                <rect width="48" height="48" rx="4" fill="#13C56B" fill-opacity="0.176471"/>
                <path d="M31.061 15.7504H28.9278V14.3759H27.0127C26.3986 13.5567 25.2652 13 23.9524 13C22.6395 13 21.5062 13.5567 20.8906 14.3745H18.9769V15.7489H16.8437C15.2728 15.7489 14 16.9799 14 18.4993V32.2496C14 33.769 15.2728 35 16.8437 35H31.061C32.632 35 33.9048 33.769 33.9048 32.2496V18.5007C33.9048 16.9813 32.632 15.7504 31.061 15.7504ZM20.1726 15.6801H21.8533C21.8533 14.8551 22.7938 14.1851 23.9539 14.1851C25.1139 14.1851 26.0544 14.8537 26.0544 15.6801H27.7351V18.6686H20.1726V15.6801ZM28.6979 30.6643H18.8909C18.566 30.6643 18.3035 30.4103 18.3035 30.0961C18.3035 29.7819 18.566 29.528 18.8909 29.528H28.6979C29.0228 29.528 29.2853 29.7819 29.2853 30.0961C29.2839 30.4103 29.0213 30.6643 28.6979 30.6643ZM28.6979 27.2884H18.8909C18.566 27.2884 18.3035 27.0344 18.3035 26.7202C18.3035 26.406 18.566 26.1521 18.8909 26.1521H28.6979C29.0228 26.1521 29.2853 26.406 29.2853 26.7202C29.2839 27.0344 29.0213 27.2884 28.6979 27.2884ZM28.6979 23.9426H18.8909C18.566 23.9426 18.3035 23.6887 18.3035 23.3745C18.3035 23.0603 18.566 22.8063 18.8909 22.8063H28.6979C29.0228 22.8063 29.2853 23.0603 29.2853 23.3745C29.2839 23.6872 29.0213 23.9426 28.6979 23.9426Z" fill="#13C56B"/>
              </svg>
              <svg v-if="index===1" xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
                <rect width="48" height="48" rx="4" fill="#50C3E6" fill-opacity="0.176471"/>
                <path d="M25 14C18.95 14 14 18.95 14 25C14 31.05 18.95 36 25 36C31.05 36 36 31.05 36 25C36 18.95 31.05 14 25 14ZM20.325 26.1C19.775 26.1 19.3625 25.55 19.3625 25C19.3625 24.45 19.775 23.9 20.4625 23.9C21.15 23.9 21.425 24.45 21.425 25C21.425 25.55 20.875 26.1 20.325 26.1ZM25 26.1C24.45 26.1 23.9 25.55 23.9 25C23.9 24.45 24.45 23.9 25 23.9C25.55 23.9 26.1 24.45 26.1 25C26.1 25.55 25.55 26.1 25 26.1ZM29.675 26.1C29.125 26.1 28.575 25.6875 28.575 25C28.575 24.3125 28.9875 23.9 29.675 23.9C30.3625 23.9 30.775 24.3125 30.775 25C30.775 25.6875 30.225 26.1 29.675 26.1Z" fill="#31A6E8"/>
              </svg>
              <svg  v-if="index===2" xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
                <rect width="48" height="48" rx="4" fill="#6691E7" fill-opacity="0.176471"/>
                <path d="M35 18.6516C35 17.187 33.813 16 32.3484 16H15.6516C14.187 16 13 17.187 13 18.6516V31.7389C13 33.2034 14.187 34.3905 15.6516 34.3905H32.3484C33.813 34.3905 35 33.2034 35 31.7389V18.6516Z" fill="#6D7080"/>
                <path d="M24.7027 29.461C24.7027 29.0024 24.3253 28.625 23.8668 28.625H17.1792C16.7206 28.625 16.3433 29.0024 16.3433 29.461C16.3433 29.9195 16.7206 30.2969 17.1792 30.2969H23.8668C24.3253 30.2969 24.7027 29.9195 24.7027 29.461ZM26.3745 25.1961C26.3742 24.9744 26.2865 24.7617 26.1305 24.6042C25.973 24.4482 25.7603 24.3605 25.5386 24.3601H17.1793C16.9576 24.3605 16.745 24.4482 16.5875 24.6042C16.2658 24.9302 16.2658 25.4619 16.5875 25.7879C16.745 25.9439 16.9576 26.0316 17.1793 26.032H25.5386C25.761 26.032 25.9733 25.9434 26.1305 25.7879C26.2865 25.6304 26.3742 25.4178 26.3745 25.1961ZM31.3901 20.9311C31.3901 20.4726 31.0128 20.0952 30.5542 20.0952H17.1793C16.7208 20.0953 16.3435 20.4726 16.3435 20.9311C16.3435 21.3897 16.7208 21.767 17.1793 21.7671H30.5542C31.0128 21.7671 31.3901 21.3897 31.3901 20.9311Z" fill="white"/>
              </svg>
              <svg  v-if="index===3" xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
                <rect width="48" height="48" rx="4" fill="#E8BC52" fill-opacity="0.176471"/>
                <path d="M31.7133 13C31.6616 13 31.6122 13.003 31.5628 13.0054H16.4344C16.3849 13.003 16.3356 13 16.2838 13C14.4733 13 13.0024 14.4696 13.0024 16.277L13.0078 16.6239H13V31.3907H13.0078L13.0054 31.7208V31.7508C13.0054 33.5365 14.46 34.9923 16.2505 34.9923C16.3054 34.9923 16.3601 34.9892 16.4149 34.9869H31.484L31.5002 34.9892C31.5711 34.9977 31.6475 35 31.7272 35C33.5178 35 34.9723 33.5474 34.9723 31.7648V31.7209L34.9698 31.3908H34.9914V16.4789C34.9969 16.4134 35 16.3478 35 16.2822C35.0003 14.4719 33.5262 13 31.7133 13ZM29.0635 24.1816L23.0211 30.2166C22.8976 30.3392 22.7305 30.4079 22.5564 30.4077C22.4702 30.4079 22.3847 30.3911 22.305 30.3583C22.2252 30.3255 22.1528 30.2774 22.0917 30.2166L18.936 27.0652C18.6789 26.8083 18.6789 26.3935 18.936 26.1399C19.1931 25.8833 19.6085 25.8833 19.8633 26.1399L22.5564 28.8294L28.1369 23.2564C28.3942 22.9996 28.8095 22.9996 29.0635 23.2564C29.3206 23.513 29.3206 23.9278 29.0635 24.1816ZM33.2491 16.7333H14.7451V16.1921L14.7582 16.1581C14.7683 16.1304 14.7737 16.1027 14.7737 16.0788C14.7737 15.2869 15.6153 14.6415 16.653 14.6415C16.6584 14.6415 16.6691 14.6391 16.6792 14.6391L16.6947 14.6368H31.281L31.3019 14.6391C31.315 14.6415 31.3305 14.6415 31.3435 14.6415C32.3812 14.6415 33.2259 15.2869 33.2259 16.0802C33.2259 16.1026 33.2305 16.1242 33.239 16.1481L33.2491 16.1781V16.7333Z" fill="#E8BC52"/>
              </svg>
            </div>
          </div>
        </b-card-body>
      </b-card>
    </b-col>
  </b-row>
    <b-row>
      <b-col lg="12">
        <b-card no-body id="orderList">
          <b-card-header class="border-0">
            <b-row class="align-items-center gy-3">
              <b-col cols="sm">
                <h5 class="card-title mb-0">{{ title }}</h5>
              </b-col>
              <b-col sm="auto">
                <div class="d-flex gap-1 flex-wrap">
                  <div class="btn-group" role="group">
                    <b-button
                      type="button"
                      variant="outline-primary"
                      class="ms-1 dropdown-toggle"
                      data-bs-toggle="dropdown"
                      id="btnGroup1"
                      aria-expanded="false"
                    >
                      <i class="ri-settings-3-line align-bottom me-1"></i>
                      {{ $t("page.set-column") }}
                    </b-button>
                    <ul class="dropdown-menu" aria-labelledby="btnGroup1">
                      <li class="dropdown-item accordion-button-class" @click.capture.stop>
                        <label>
                          <input
                            class="form-check-input"
                            type="checkbox"
                            v-model="showAllColumns"
                            @change="changeShowAllColumns"
                          />
                          {{ $t("base.select-all") }}
                        </label>
                      </li>
                      <li
                        v-for="(item, index) in tableHeaders"
                        :key="index"
                        class="dropdown-item accordion-button-class"
                        @click.capture.stop
                      >
                        <label>
                          <input
                            class="form-check-input"
                            type="checkbox"
                            v-model="item.visible"
                            @change="changeShowColumn(item.name)"
                          />
                          {{ item.label }}
                        </label>
                      </li>
                    </ul>
                  </div>
                  <b-button
                      type="button"
                      variant="primary"
                      class="ms-1"
                    @click="download"
                      v-if="user.user_type!=='customer'&&user.user_type!=='service_company'"
                  >
                    <i class="ri-download-2-fill align-bottom me-1"></i>
                    {{ $t('page.auditing.service_follow_up') }}
                  </b-button>
                  <b-button
                      type="button"
                      variant="primary"
                      class="ms-1"
                      @click="reportModal=!reportModal"
                      v-if="user.user_type!=='customer'&&user.user_type!=='service_company'"
                  >
                    <i class="ri-upload-2-fill align-bottom me-1"></i>
                    {{ $t('page.auditing.service_upload') }}
                  </b-button>

                </div>
              </b-col>
            </b-row>
          </b-card-header>
          <b-card-body class="border border-dashed border-end-0 border-start-0">
            <b-form>
              <b-row class="g-3">
                <b-col xxl="6" sm="2">
                  <div class="search-box">
                    <input
                      type="text"
                      class="form-control search"
                      v-model="filter_value.keyword"
                      :placeholder="`${$t('page.auditing.work_order_number')}/${$t('page.auditing.customer_name')}`"
                    />
                    <i class="ri-search-line search-icon"></i>
                  </div>
                </b-col>
                <b-col xxl="2" sm="2">
                  <div class="input-light">
                    <Multiselect
                      class="form-control"
                      :placeholder="$t('base.select_customer')"
                      v-model="filter_value.customer"
                      :close-on-select="true"
                      :searchable="false"
                      :create-option="false"
                      :options="clientName"
                      :can-clear="false"
                    />
                  </div>
                </b-col>
                <b-col xxl="2" sm="2">
                  <div class="input-light">
                    <Multiselect
                      class="form-control"
                       :placeholder="$t('page.engineer')"
                      v-model="filter_value.engineer"
                      :close-on-select="true"
                      :searchable="false"
                      :create-option="false"
                      :options="engineer"
                      :can-clear="false"
                    />
                  </div>
                </b-col>
                <!--       隐藏服务评价筛选         -->
                <b-col xxl="2" sm="2" v-if="false">
                  <feedback-filter
                    v-model:value="filter_value.feedback"
                  ></feedback-filter>
                </b-col>

                <b-col cols="2" class="d-flex justify-content-end align-items-end">
                    <b-button
                      type="button"
                      variant="primary"
                      @click="doFilter"
                      class="me-2"
                    >
                      <i class="ri-search-line me-1 align-bottom"></i>
                      {{ $t("search") }}
                    </b-button>
                    <b-button type="button" variant="info" @click="resetSearch">
                      <i class="ri-restart-line me-1 align-bottom"></i>
                      {{ $t("base.reset") }}
                    </b-button>
                </b-col>
              </b-row>
            </b-form>
          </b-card-body>
          <b-card-body class="pt-0">
            <div>
              <ul
                class="nav nav-tabs nav-tabs-custom nav-success mb-3"
                role="tablist"
              >
                <li
                  class="nav-item"
                  v-for="(tabItem, index) in tabOptions"
                  :key="index"
                >
                  <b-link
                    class="nav-link py-3"
                    :class="
                     tabItem.value == filter_value.status ? 'active' : ''
                    "
                    data-bs-toggle="tab"
                    role="tab"
                    @click.prevent="checkTab(tabItem.value)"
                    aria-selected="true"
                  >
                    <i :class="tabItem.icon" class="me-1 align-bottom"></i>
                    {{ tabItem.text }}
                    <b-badge
                      v-if="tabItem.tipNum > 0"
                      variant="danger"
                      class="align-middle ms-1"
                      >{{ tabItem.tipNum }}</b-badge
                    >
                  </b-link>
                </li>
              </ul>

              <div class="table-responsive table-card mb-1">
                <table class="table table-nowrap align-middle" id="orderTable">
                  <thead class="text-muted table-light">
                    <tr class="text-uppercase">
                      <!--                      <th scope="col" style="width: 25px">-->
                      <!--                        <div class="form-check">-->
                      <!--                          <input class="form-check-input" type="checkbox"  v-model="checkedAll" @change="checkAllChange" />-->
                      <!--                        </div>-->
                      <!--                      </th>-->
                      <template
                        v-for="(item, index) in visibleTableHeaders"
                        :key="index"
                      >
                        <th v-show="item.visible">{{ item.label }}</th>
                      </template>
                    </tr>
                  </thead>
                  <tbody class="list form-check-all">
                  <template
                      v-for="(item, index) in orders" :key="index"
                  >
                    <tr>
                      <!--                      <th scope="row">-->
                      <!--                        <div class="form-check">-->
                      <!--                          <input class="form-check-input" type="checkbox" name="chk_child" :checked="checkedIds.includes(item.id)" @change="checkChange(item.id)" />-->
                      <!--                        </div>-->
                      <!--                      </th>-->
                      <td v-show="visibleTableHeaders[0].visible" class="number" :rowspan="item.auditing_order_report.length||1">
                        <router-link
                            :to="'/auditing-order-detail/' + item['id']"
                        >{{ item['number'] }}</router-link
                        >
                      </td>
                      <td v-show="visibleTableHeaders[1].visible" class="type_txt" :rowspan="item.auditing_order_report.length||1">
                        {{item['type_txt']&&$t(item['type_txt'])||'-'}}
                      </td>
                      <td v-show="visibleTableHeaders[2].visible" class="ka_level" :rowspan="item.auditing_order_report.length||1">
                        {{ item['ka_level']&&item['ka_level']}}
                      </td>
                      <td v-show="visibleTableHeaders[3].visible" class="deadline" :rowspan="item.auditing_order_report.length||1">
                        {{ item['created_at']&&moment(item['deadline']).format('YYYY-MM-DD')||'-'}}
                      </td>

                        <td v-show="visibleTableHeaders[4].visible"  class="status" :rowspan="item.auditing_order_report.length||1">
                          <wo-status-etc
                            :value="item['status']"
                            field-name="status"
                            :wo-data="item"
                          />
                        </td>


                      <!--            延期状态            -->

                      <td v-show="visibleTableHeaders[5].visible" class="is_delay" :rowspan="item.auditing_order_report.length||1">
                        <div >
                          <div>
                              <span
                                  v-if="item['is_delay']"
                                  class="badge badge-soft-danger dot-prefix"
                              >
                                {{ $t("page.overdue") }}
                              </span>
                            <span
                                v-else
                                class="badge badge-soft-success dot-prefix"
                            >{{ $t("page.not-overdue") }}</span
                            >
                          </div>

                        </div>
                      </td>
                      <td v-show="visibleTableHeaders[6].visible" class="customer_txt" :rowspan="item.auditing_order_report.length||1">
                        {{ item['customer_txt']&&item['customer_txt']}}
                      </td>
                      <td v-show="visibleTableHeaders[7].visible" class="service_company_txt" :rowspan="item.auditing_order_report.length||1">
                        {{ item['service_company_txt']&&item['service_company_txt']}}
                      </td>
                      <td v-show="visibleTableHeaders[8].visible" class="owner_engineer_txt" :rowspan="item.auditing_order_report.length||1">
                        {{ item['owner_engineer_txt']&&item['owner_engineer_txt']}}
                      </td>
                      <td v-show="visibleTableHeaders[9].visible" class="contact_name">
                        {{item.auditing_order_report&&item.auditing_order_report[0]&&item.auditing_order_report[0].contact_name}}
                      </td>

                      <td v-show="visibleTableHeaders[10].visible" class="contact_number">
                        {{item.auditing_order_report&&item.auditing_order_report[0]&&item.auditing_order_report[0].contact_number}}
                      </td>
                      <td v-show="visibleTableHeaders[11].visible" class="status_txt">
                        <!-- {'执行中':'#6691E7','已签字':'#13C56B','待签字':'#435285','待审核':'#f7b84b','已完成':'#0AB39C'} -->
                        <div v-if="item.auditing_order_report&&item.auditing_order_report[0]&&item.auditing_order_report[0].status"  
                        style="border-radius: 4px;background: #6691E7;padding:0 5px;width: fit-content;height: 20px;color:#ffffff;text-align: center;"   
                        :style="`background:${getReportStautsColor(item.auditing_order_report&&item.auditing_order_report[0]&&item.auditing_order_report[0].status)}`">
                          {{AUDITING_ORDER_REPORT_STAUTS[(item.auditing_order_report&&item.auditing_order_report[0]&&item.auditing_order_report[0].status)].txt}}
                        </div>
                      </td>
                      <td v-show="visibleTableHeaders[12].visible" class="amount">
                        {{item.auditing_order_report&&item.auditing_order_report[0]&&(!isNaN(parseFloat(item.auditing_order_report[0].amount))&&Number(item.auditing_order_report[0].amount).toFixed(2))||'-'}}
                      </td>
                      <td v-show="visibleTableHeaders[13].visible" class="possibility">
                          <el-progress style="zoom: 0.7" width="60" type="circle" :percentage="item.auditing_order_report&&item.auditing_order_report[0]&&item.auditing_order_report[0].possibility||0" :color="colors" />
                      </td>
                    </tr>
                    <template v-if="item.auditing_order_report.length > 1">
                      <tr v-for="(a, i) in item.auditing_order_report.slice(1)" :key="i">
                        <td v-show="visibleTableHeaders[9].visible" class="contact_name">
                          {{a.contact_name}}
                        </td>
                        <td v-show="visibleTableHeaders[10].visible" class="contact_number">
                          {{a.contact_number}}
                        </td>
                        <td v-show="visibleTableHeaders[11].visible" class="status_txt">
                          <div  v-if="a.status"  style="border-radius: 4px;background: #6691E7;padding:0 5px;width: fit-content;height: 20px;color:#ffffff;text-align: center;"   class='mb-1 mt-1'  :key="a.id" :style="`background:${getReportStautsColor(a.status)}`">
                            {{ AUDITING_ORDER_REPORT_STAUTS[a.status].txt }}
                          </div>
                        </td>
                        <td v-show="visibleTableHeaders[12].visible" class="amount">
                          {{(!isNaN(parseFloat(a.amount))&&Number(a.amount).toFixed(2))||'-'}}
                        </td>
                        <td v-show="visibleTableHeaders[13].visible" class="possibility">
                            <el-progress  style="zoom: 0.7" width="60" type="circle" :percentage="a.possibility&&a.possibility||0" :color="colors" />
                        </td>

                      </tr>
                    </template>
</template>

                  </tbody>
                </table>
                <table-loading
                  :count="count"
                  :table-loading="tableLoading"
                  :table-loaded="tableLoaded"
                ></table-loading>
              </div>
            </div>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <Pagination
      v-if="tab_info_length"
      v-model:page="page"
      v-model:perPage="perPage"
      :pages="pages"
      :prePageOption="prePageOption"
      :tab_info_length="tab_info_length"
      @update:page="pageChange"
      @update:perPage="pageSizeChange"
      class="me-5 my-3"
    ></Pagination>
    <b-modal
        v-model="reportModal"
        hide-footer
        dialog-class="modal-dialog-centered"
        class="v-modal-custom"
        :title="$t('page.auditing.service_upload')"
        centered
        size="xl"

    >
      <div class="modal-body">
        <DropZone
            @drop.prevent="drop"
            @change="selectedFile"
            :fileInfo="{
                title: this.$t('page.files_upload.click_upload_pictures_videos_documents_auditing'),
                accept: this.$t('page.files_upload.type_auditing'),
                limit: '50M',
              }"
            :accept="'.xls,.xlsx,'"
        />
      </div>

    </b-modal>
  </Layout>
</template>
<style scoped>
.dot-prefix {
  display: flex;
  align-items: center;
  width: fit-content;
  &::before {
    content: "";
    display: inline-block;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: #f06548;
    margin-right: 0.125rem;
  }
}
.dot-prefix.badge-soft-success::before {
  background-color: #1abc9c;
}
</style>